import React, { Component, useState, useEffect  } from 'react'; //imrc Enter

import { useContext } from 'react';
import { ShopContext } from './shopinfo';
import { useShop } from "./shopinfo";
import { AuthContext } from './authcontext';
import { useAuth } from './authcontext';

import SafeDisplayText from './displaytexthtml';




const HeaderContact = () => {
 
            const { shopData} = useShop();
            
            const { additionalInfo } = useContext(ShopContext);
            const { user } = useAuth();
            const {loggedIn, userData} = useContext(AuthContext);
            const userTyp = userData?.typ;

            
            const adresse = additionalInfo?.records?.[0];

            if (!shopData) return (<div>
                                        {!loggedIn ?  (
                                                        <div className="umBorderLeft">
                                                             <div
                                                                    dangerouslySetInnerHTML={{ __html: shopData.kontakt_header }}
                                                                />
                                                            <div className="headerServiceZeiten">
                                                                <b>Service-Zeiten:&nbsp;</b>  23:59 - 00:01 Uhr
                                                            </div>
                                                            <div className="headerOffenZeiten">
                                                                <b>Öffnungszeiten:&nbsp;</b> 0:10 - 23:50 Uhr
                                                            </div>
                                                        </div> 
                                                        ) : ( 
                                                            <div className="umBorderLeft">
                                                                angemeldet als: {userTyp === 'A' ? ( <div>Admin</div>) : ( <div>nicht</div>)} <br /><br />
                                                                <b>Schuhnachrichten Vertrieb</b> <br />
                                                                A House in the Middle of the Road 35 <br />
                                                                Chicago, Illinois
                                                                
                                                            </div>
                                                        )
                                            }

                                </div>  
            );
            
            return ( <div>
                        
                                            {!loggedIn ?  (
                                                        <div className="umBorderLeft">
                                                            <div className="headerHotline">
                                                                <SafeDisplayText html={shopData.kontakt_header} />
                                                            </div>
                                                            
                                                        </div> 
                                                        ) : ( 
                                                            <div className="umBorderLeft">
                                                                angemeldet als: <br /><br />
                                                                <b>{user.aml}</b> <br />
                                                                <b>{adresse?.vorname} {adresse?.nachname}</b> <br />
                                                                <b> {adresse?.plz} {adresse?.ort}</b>
                                                                
                                                            </div>
                                                        )
                                            }
                                    
                                    

            
                </div>  


        );
    }


export default HeaderContact;





